import {PhoneView, SimpleText} from '@/styles';
import {useTheme} from 'styled-components';

function NotAvailablePage() {
  const theme = useTheme();
  return (
    <>
      <PhoneView
        style={{
          backgroundColor: theme.colors.background.primary,
          width: '100%',
          height: '100vh',
          paddingTop: '100px',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <SimpleText
          style={{
            fontSize: '22px',
            fontWeight: 'bold',
            maxWidth: '350px',
            textAlign: 'center',
            color: theme.colors.error,
          }}
          text={
            'صفحه مورد نظر در دسترس نمی‌باشد. لطفا با پشتیبانی سایت تماس حاصل فرمایید یا دقایقی صبر کنید و مجددا تلاش فرمایید'
          }
        />
      </PhoneView>
    </>
  );
}

export default NotAvailablePage;
